import Pusher from "pusher-js";
import { getItemFromLocalStorage } from "./utils/localStorage";
import { TOKEN } from "./constants/const";

/**
 * Shared Pusher client for community realtime (feed + live event rooms).
 *
 * Replaces the previous getstream.io client. The backend bridges to
 * BuddyBoss/WordPress and broadcasts over Pusher — the same realtime service the
 * platform chat already uses. A single generic auth endpoint authorizes every
 * presence channel (feed and per-event). See COMMUNITY_FRONTEND_GUIDE.md §5/§8.
 */

// Pusher presence channels used by the community feature.
export const FEED_CHANNEL = "presence-community-feed";
export const eventChannel = (eventId) => `presence-community-event-${eventId}`;

// Single generic Pusher auth endpoint for all community channels.
const REALTIME_AUTH_PATH = "/client/community/events/realtime/auth";

let instance = null;

/**
 * Lazily create (and cache) one Pusher connection for the whole community
 * feature. Returns null during SSR.
 */
export const getCommunityPusher = () => {
    if (typeof window === "undefined") return null;
    if (instance) return instance;

    instance = new Pusher(process.env.GATSBY_PUSHER_CLIENT_SECRET, {
        cluster: process.env.GATSBY_PUSHER_CLUSTER || "mt1",
        authorizer: (channel) => ({
            authorize: (socketId, callback) => {
                const token = getItemFromLocalStorage(TOKEN);
                fetch(`${process.env.GATSBY_API_URL}${REALTIME_AUTH_PATH}`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "x-auth-token": `Bearer ${token}`,
                    },
                    body: JSON.stringify({
                        socket_id: socketId,
                        channel_name: channel.name,
                    }),
                })
                    .then(async (res) => {
                        if (!res.ok) throw new Error("Pusher auth failed");
                        callback(null, await res.json());
                    })
                    .catch((err) => callback(err, null));
            },
        }),
    });

    return instance;
};

/** Tear down the connection on logout so the next login re-auths cleanly. */
export const resetCommunityPusher = () => {
    if (instance) {
        instance.disconnect();
        instance = null;
    }
};
